import React from 'react';
import loadable from '@loadable/component';

import MatchErrorBoundary from 'modules/match/components/Match/MatchErrorBoundary';
import { Modules } from '../../../types';
import MatchStub from '../components/Match/MatchStub';

export { default as MarketsTabConfigsCtx } from './MarketsTabConfigsCtx';

interface Props {
    slugOrId: string;
}

export const loadMatchModule: () => Promise<
    Modules['match']
> = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "match-module" */ '../index');

export const AsyncMatch = loadable(loadMatchModule, {
    resolveComponent: ({ default: match }) => match.components.MatchDataFetcher,
    fallback: <MatchStub isLoading={true} />,
});

export const AsyncSidebarMarketList = loadable(loadMatchModule, {
    resolveComponent: ({ default: match }) =>
        match.components.SidebarMarketList,
});

export const AsyncMatchWithErrorBoundary: React.FC<Props> = ({ slugOrId }) => (
    <MatchErrorBoundary>
        <AsyncMatch slugOrId={slugOrId} />
    </MatchErrorBoundary>
);
